import {
  NovuProvider,
  INovuProviderProps,
  IPopoverNotificationCenterProps,
  INotificationBellProps,
  INotificationCenterProps
} from "@novu/notification-center";
import { Link } from "react-router-dom";

import notficationStyles from "./notificationStyle";
import { FC, Fragment, useEffect, useState } from "react";
import Novu from "./novu";
import { useGetFeedsQuery } from "./slice/notificationSlice";
import CustomNotificationCenter from "./customNotification";
import { Popover, Transition } from "@headlessui/react";
import CustomBell from "./customBellNew";
import dayjs from "dayjs";
import ErrorListAlerts from "../../../pages/event-creation-workflow/errorListAlert";

export interface NotifyError {
  severity: "error" | "warning" | "success" | "info";
  label: string;
  description?: string;
  variants?: "outlined" | "filled";
  action?: "close" | "undo" | undefined;
  alertboxStyles?: "inline" | "block";
  open: boolean;
  setOpen?(value: boolean): void;
  actionButtonName?: string;
  actionButtonClick?: () => void;
  messageList?: [];
  autoHideDuration?: number;
  timeoutCallback?: () => void;
}

interface NotificationProps extends Partial<INovuProviderProps> {
  subscriberId: string;
  popOver?: Partial<IPopoverNotificationCenterProps | INotificationCenterProps>;
  bellICon?: FC<INotificationBellProps>;
  expirationLimit: {
    value: number;
    unit: dayjs.UnitType;
  };
  mobileHref?: string;
}

const Notification: FC<NotificationProps> = (props) => {
  const { data, error, isError } = useGetFeedsQuery(undefined, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true
  });

  const [notifyErrors, setNotifyErrors] = useState<Partial<NotifyError>[] | []>(
    []
  );

  function getAlerts(notifyErrors: NotifyError[]) {
    return notifyErrors.map((notfiyError) => (
      <ErrorListAlerts
        severity={notfiyError?.severity}
        label={notfiyError?.label}
        messageList={notfiyError?.messageList}
      />
    ));
  }

  useEffect(() => {
    if (isError) {
      setNotifyErrors((oldErrors) => {
        if (oldErrors?.length > 0) {
          return [
            ...oldErrors,
            {
              label: "Failed!",
              severity: "error",
              messageList: [
                "Error while fetching All the feeds"
              ] as unknown as []
            }
          ];
        } else {
          return [
            {
              label: "Failed!",
              severity: "error",
              messageList: [
                "Error while fetching All the feeds"
              ] as unknown as []
            }
          ];
        }
      });
    }
  }, [isError, data, error]);

  return (
    <NovuProvider
      applicationIdentifier={Novu.APP_ID!}
      socketUrl={Novu.NOVU_SOCKET_URL!}
      backendUrl={Novu.NOVU_BACKEND_URL!}
      initialFetchingStrategy={{
        fetchNotifications: false,
        fetchUserPreferences: true,
        fetchOrganization: true,
        fetchUnseenCount: true,
        fetchUserGlobalPreferences: true
      }}
      i18n={"en"}
      styles={notficationStyles}
      {...props}
    >
      {props.mobileHref && (
        <Link
          to={props.mobileHref}
          className="sm:hidden inline-flex items-center text-sm font-semibold text-secondary hover:text-primary"
          aria-label="Notifications"
        >
          {props.bellICon ? <props.bellICon /> : <CustomBell />}
        </Link>
      )}
      <Popover
        className={`relative ${props.mobileHref ? "hidden sm:block" : ""}`}
      >
        {({ open }) => (
          <>
            <Popover.Button
              id="notification"
              aria-label="Open notifications center"
              className={`inline-flex items-center text-sm font-semibold text-left text-secondary hover:text-primary focus:text-primary focus-visible:ring-2 focus-visible:ring-dark-widget rounded-md ${
                open ? "outline-none text-primary" : "outline-none"
              }`}
              data-testid="notificationBtn"
              disabled={location.pathname === "/notifications" && true}
            >
              {props.bellICon ? <props.bellICon /> : <CustomBell />}
            </Popover.Button>
            {location.pathname !== "/notifications" && (
              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel
                  className="absolute  z-50
              -right-20   
              sm:-right-24   
              md:w-[318px] w-screen
              md:min-w-[24rem]
              md:-left-[18rem] 
              top-12
            "
                >
                  {/* absolute inset-0 top-16 -left-[15rem] md:-left-[350px] z-20 -left-[10.5rem]  md:-left-[18rem] */}
                  <CustomNotificationCenter
                    {...props}
                    setNotifyErrors={setNotifyErrors}
                  />
                </Popover.Panel>
              </Transition>
            )}
          </>
        )}
      </Popover>
      {notifyErrors !== undefined && notifyErrors?.length > 0 && (
        <div>{getAlerts(notifyErrors as any)}</div>
      )}
    </NovuProvider>
  );
};

export default Notification;
